import { Avatar, Text } from 'components';
import { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { routes } from '../../constants';
import TopRank from '../../assets/images/topRank.png';

type TProps = {
  rank: number;
  value: number;
  unit?: string;
  user: { id: number; nickname: string; avatar: string };
};

function RankingItem({ rank, value, unit, user }: TProps) {
  const navigate = useNavigate();

  const [styleRank, isTopRanking] = useMemo(() => {
    let textColor: `text-${string}`;
    let background = '';
    let borderColor: string;
    let avatarSize: `w-${string}` | `h-${string}` = 'w-14';
    let avatarBorder = '';
    let textSize: number = 14;

    switch (rank) {
      case 1:
        textColor = 'text-primary';
        borderColor = 'border-primary';
        avatarSize = 'w-[40%]';
        textSize = 18;
        break;
      case 2:
        background = 'bg-gradient-to-r from-blue-50';
        textColor = 'text-blue-300';
        borderColor = 'border-blue-300';
        break;
      case 3:
        background = 'bg-gradient-to-r from-orange-50';
        textColor = 'text-orange-300';
        borderColor = 'border-orange-300';
        break;
      default:
        textColor = 'text-neutral-600';
        borderColor = 'border-neutral-900';
        break;
    }
    return [
      {
        textColor,
        background,
        borderColor,
        avatarSize,
        avatarBorder,
        textSize,
      },
      rank === 1,
    ];
  }, [rank]);

  const handleNavigateToDetail = () => {
    navigate(routes.DETAIL_FEMALE.replace(':id', String(user.id)));
  };

  return (
    <>
      <div
        className={`${styleRank.borderColor} ${styleRank.background} py-4 px-6 relative to-white flex items-center border-[1.5px] border-solid rounded-xl`}
        style={
          isTopRanking ? { background: `url(${TopRank}) top / cover` } : {}
        }
      >
        <Text
          bold
          fontSize={24}
          className={`tracking-widest ${isTopRanking && 'absolute left-6'}`}
          textColor={styleRank.textColor}
        >
          {String(rank).padStart(2, '0')}
        </Text>
        <div
          className={`flex items-center flex-1 ${
            isTopRanking ? 'justify-center flex-col gap-2 pt-4' : ''
          }`}
        >
          <Avatar
            size={styleRank.avatarSize}
            circle
            url={user.avatar}
            className={`border-[3px] border-solid  ${styleRank.borderColor} ${
              isTopRanking ? 'mt-3 mr-2.5' : 'mx-4'
            } `}
            canViewFull={false}
            onClick={handleNavigateToDetail}
          />
          <Text
            bold
            fontSize={styleRank.textSize}
            className="line-clamp-1 cursor-pointer hover:underline"
            onClick={handleNavigateToDetail}
          >
            {user.nickname}
          </Text>
        </div>
      </div>
    </>
  );
}

export default RankingItem;
